import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance.js";

export const fetchStudentPublicProfile = createAsyncThunk(
  "studentPublic/fetchStudentPublicProfile",
  async (studentId, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`/student/${studentId}`);
      // console.log(data);

      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch student profile"
      );
    }
  }
);
